function Counter3_3() {
  return (
    <>
      <circle cx="4.5" cy="4.5" r="2.5" fill="#404040" />
      <circle cx="11.5" cy="4.5" r="2.5" fill="#404040" />
      <circle cx="4.5" cy="11.5" r="2.5" fill="#404040" />
    </>
  );
}

export default Counter3_3;
